import { Component } from "@angular/core";
import { AccountFacade } from "@youm-front/account/data-access";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html"
})
export class AppComponent {
  readonly conf2SignInFailure$ = this.accountFacade.conf2SignInFailure$;

  constructor(private readonly accountFacade: AccountFacade) {}
}
